<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="currency">Currency</v-tab>
      <v-tab key="currency_kind">Kind</v-tab>
      <v-tab key="currency_group">Group</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="currency">
        <r-currency-page/>
      </v-tab-item>
      <v-tab-item key="currency_kind">
        <r-currency-kind-page/>
      </v-tab-item>
      <v-tab-item key="currency_group">
        <r-currency-group-page/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RCurrencyPage from "@/modules/redactor/views/currency/r-currency-page.vue";
import RCurrencyKindPage from "@/modules/redactor/views/currency-kind/r-currency-kind-page.vue";
import RCurrencyGroupPage from "@/modules/redactor/views/currency-group/r-currency-group-page.vue";

export default {
  name: "r-currencies-holder-page",
  components: {
    RCurrencyPage,
    RCurrencyKindPage,
    RCurrencyGroupPage,
  },
  data: () => ({
    tab: null
  })
}

</script>